/** Close other open hub select menus when one opens (native details/select pattern). */
export function closeOpenHubFieldSelectMenus(except?: Element | null) {
	const hubs = document.querySelectorAll(".hub");
	for (const hub of hubs) {
		hub.querySelectorAll(".hub-field-select.is-open").forEach((node) => {
			if (except && (node === except || node.contains(except))) return;
			node.classList.remove("is-open");
			node.dispatchEvent(new CustomEvent("bafe:hub-field-select-close"));
		});
	}
}

export function closeOpenDetailsSelects(except?: HTMLDetailsElement | null) {
	const root = except?.closest(".hub") ?? except?.closest("dialog.modal") ?? document;
	root.querySelectorAll("details.select[open]").forEach((node) => {
		if (except && node === except) return;
		const other = node as HTMLDetailsElement;
		if (!other.open) return;
		other.open = false;
		other.dispatchEvent(new Event("toggle", { bubbles: false }));
	});
}

export function closeSiblingSelectMenus(details: HTMLDetailsElement) {
	if (!details.open) return;
	closeOpenHubFieldSelectMenus(details);
	const root = details.closest(".hub") ?? details.closest("dialog.modal") ?? document.body;
	root.querySelectorAll("details.select[open]").forEach((node) => {
		if (node === details) return;
		const other = node as HTMLDetailsElement;
		if (!other.open) return;
		other.open = false;
		other.dispatchEvent(new Event("toggle", { bubbles: false }));
	});
}

/** Close every hub field / details menu before opening a modal button select. */
export function closeHubMenusForModalSelect(host: HTMLElement) {
	closeOpenHubFieldSelectMenus(host);
	closeOpenDetailsSelects(null);
}
